export function readInvitation(location) {
    const params = new URLSearchParams(location.search);
    const hash = new URLSearchParams(location.hash.replace(/^#/, ''));
    const encoded = hash.get('invite');
    return {
        email: params.get('email'),
        tenant: params.get('tenant'),
        temporaryPassword: encoded ? decodeBase64Url(encoded) : null,
    };
}
/** Drop the fragment from the address bar (and history) once it has been read. */
export function clearInvitationFragment() {
    if (typeof window === 'undefined' || !window.location.hash)
        return;
    try {
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    }
    catch {
        // A sandboxed frame may refuse; the fragment is still only in this tab.
    }
}
export function decodeBase64Url(value) {
    try {
        const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
        const bytes = Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
        return new TextDecoder().decode(bytes);
    }
    catch {
        return null;
    }
}
export function encodeBase64Url(value) {
    const bytes = new TextEncoder().encode(value);
    let binary = '';
    for (const b of bytes)
        binary += String.fromCharCode(b);
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
//# sourceMappingURL=invitation-link.js.map